import { render, staticRenderFns } from "./ModalHomeSuccess.vue?vue&type=template&id=59b56ca6&scoped=true&"
import script from "./ModalHomeSuccess.vue?vue&type=script&lang=js&"
export * from "./ModalHomeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ModalHomeSuccess.vue?vue&type=style&index=0&id=59b56ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b56ca6",
  null
  
)

export default component.exports